// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2X8S3","name":"ConsentHeader_name__2gDlo","birthday":"ConsentHeader_birthday__3XXQk","skeleton":"ConsentHeader_skeleton__3lVW0"};